import styled from 'styled-components';
import { Icon } from '../icon/icon.component.js';
import { marginStyles, disabled, formElementErrorStyles, formElementFocusStyles } from '../../styles/components.js';

const SelectGroup = styled.div `
  max-width: 400px;
  min-height: ${props => props.minHeight};
  width: 100%;

  ${props => marginStyles(props.margin)};

  ${props => props.disabled && disabled(props)}
`;
const StyledSelect = styled.select `
  appearance: none;
  background-color: ${props => props.theme.colors.background.primary};
  border-radius: ${props => props.theme.borderRadii.small};
  border: 1px solid ${props => props.theme.colors.background.controls};
  box-sizing: border-box;
  color: ${props => props.theme.colors.content.primary};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'default')};
  font-family: ${props => props.theme.fontFamilies.main.regular};
  -webkit-font-smoothing: antialiased;
  font-size: ${props => props.theme.fontSizes[500]};
  height: 48px;
  /* If line-height is below 1.2, descenders get cut off, so we can’t leave it up to the theme */
  line-height: 1.2;
  opacity: ${props => props.disabled ? props.theme.opacities.low : props.theme.opacities.high};
  padding: 0 32px 0 16px;
  width: 100%;

  ${formElementErrorStyles}

  &:focus {
    ${formElementFocusStyles}
  }
`;
const OptionsGroup = styled.div `
  position: relative;
`;
const Caret = styled(Icon).attrs(props => ({
    'aria-hidden': true,
    icon: props.icon,
    opacity: props.disabled ? 'low' : 'high',
})) `
  position: absolute;
  pointer-events: none;
  top: 0;
  right: 16px;
  bottom: 0;
  margin: auto 0;
`;

export { Caret, OptionsGroup, SelectGroup, StyledSelect };
